<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <SchoolTypeTabs
        :schoolType="schoolType"
        v-model="currentTab"
        @delete="deleteSchoolType"
        @edit="editSchoolType"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="school_type">
          <SchoolTypeDetails :schoolType="schoolType"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { schoolsTypesService } from '../../utils/services/schoolsTypes.service';
  import SchoolTypeTabs from '../../components/app/SchoolsTypes/SchoolTypeTabs';
  import SchoolTypeDetails from '../../components/app/SchoolsTypes/SchoolTypeDetails';
  import SchoolTypeModal from '../../components/modals/SchoolsTypes/SchoolTypeModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'SchoolTypeShow',
    components: {
        Loader,
        SchoolTypeTabs,
        SchoolTypeDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        schoolType: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchSchoolType(id) {
        return schoolsTypesService.get(id)
        .then(response => {
          this.schoolType = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteSchoolType() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return schoolsTypesService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.SCHOOL_TYPE}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editSchoolType() {
          this.showModal({
              component: SchoolTypeModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('SCHOOL_TYPE'),
                onSave: (
                  form,
                  error,
                ) => schoolsTypesService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchSchoolType(this.id);
      this.loading = false;
    },
  };
</script>
